import {Flag} from 'platform/components';
import {HStack} from 'platform/foundation';

import {institutionOptions} from '@dms/shared';

interface ConsentRecipientInstitutionsProps {
  institutionTypes: string[];
}

export function ConsentRecipientInstitutions(props: ConsentRecipientInstitutionsProps) {
  return (
    <HStack spacing={1} wrap>
      {institutionOptions
        .filter((option) => props.institutionTypes.includes(option.value))
        .map((option) => (
          <Flag
            key={option.value}
            colorScheme="neutral"
            isSubtle
            size="small"
            label={option.label}
          />
        ))}
    </HStack>
  );
}
